<template>
    <div class="page community-detail">

        <community-detail-skeleton v-if="loading" style="margin-bottom: 100vh"></community-detail-skeleton>

        <div v-else>
            <div class="community-detail-box">
                <h3 class="community-detail-title">{{detail.title}}</h3>
                <div style="padding: 0 15px 15px">
                    <div class="community-detail-time">{{detail.created_at ? detail.created_at.substring(0,7) : null}} 阅读 {{detail.view_count}}</div>
                </div>
                <div class="clear" style="margin-top: 15px"></div>

                <div>
                    <div class="community-detail-content">
                        <div class="rich_media_inner" v-html="detail.content"></div>
                    </div>
                </div>
            </div>

            <img @click="applyHelp(detail)" class="course-detail-home-button" src="/static/bytx/detail_apply_btn.svg" alt="">
            <img @click="goWechat()" class="course-detail-share-button" src="/static/bytx/detail_contact_btn.svg" alt="">

            <div class="line"></div>

            <div class="comment" style="margin-top: 10px">
                <div class="comment-title">评论</div>
                <div class="comment-section" v-for="item in comment" :key="item.id">
                    <div class="comment-section-photo">
                        <img :src="item.avatar" alt="">
                    </div>
                    <div class="comment-section-content">
                        <div class="comment-section-content-author" @click="reComment(item)">{{item.name}}</div>
                        <div class="comment-section-content-detail" @click="reComment(item)">{{item.content}}</div>
                        <div class="comment-section-content-bottom">
                            <div class="comment-section-content-time">{{item.created_at}}</div>
                            <div class="comment-section-content-point" @click="pointLikeComment(item)">
                                <span v-if="item.isLike"><van-icon name="/static/img/course/icon_course_like_on.svg" /></span>
                                <span v-else><van-icon name="/static/img/course/icon_course_like_off.svg" /></span>
                                {{item.like_count == 0 ? '赞' : item.like_count}}
                            </div>
                            <div class="clear"></div>
                            <div class="comment-section-content-children" v-if="item.children != null && item.children.length > 0">
                                <div v-for="val in item.children"> <span @click="reCommentChild(val)">{{val.name}}</span><span style="color: #404040" v-if="val.reply_name != ''"> 回复 </span><span @click="reCommentChild(val)">{{val.reply_name}}</span>：{{val.content}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>

            <div class="community-detail-footer">
                <div class="community-detail-footer-box">
                    <div :class="'community-detail-footer-left '+ (comment_text!=''?'comment_in':'')">
                        <van-field round
                                   left-icon="/static/img/course/icon_course_text.svg"
                                   v-model="comment_text"
                                   :placeholder="comment_placeholder"
                                   @click="checkUserLogin"
                            >
                        </van-field>
                    </div>
                    <div :class="'community-detail-footer-right '+ (comment_text!=''?'comment_in':'')">
                        <van-grid :column-num="3" :border="false" v-if="comment_text == ''">
                            <van-grid-item @click="favorite()" v-if="detail.isFavorite" icon="/static/img/course/icon_course_favorite_on_20.svg" text="已收藏" />
                            <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_20.svg" text="收藏" />
                            <van-grid-item @click="pointLike()" v-if="detail.isLike" icon="/static/img/course/icon_course_like_on.svg" text="有帮助" :badge="detail.like_count"/>
                            <van-grid-item @click="pointLike()" v-else icon="/static/img/course/icon_course_like_off.svg" text="有帮助" :badge="detail.like_count"/>
                            <van-grid-item @click="openShareData" icon="/static/img/course/icon_course_share_20.svg" text="转发" />
                        </van-grid>
                        <div class="community-detail-footer-right-btn" v-else>
                            <van-button type="danger" size="medium" @click="createComment" color="#0FB7AD">
                                发送
                            </van-button>
                        </div>
                    </div>
                </div>
                <van-number-keyboard safe-area-inset-bottom />
            </div>

            <van-dialog class="apply_form" v-model="applyFormDialog" :showConfirmButton="false">
                <template slot="title">
                    <div class="close-pop" @click="closeApplyForm">
                        <img src="/static/bytx/popup_close_icon.svg" alt="">
                    </div>
                    <h3 v-if="!detail.isApply">申请公益救助</h3>
                    <h3 v-else>您已申请，无需重复提交！</h3>
                </template>
                <div class="clear"></div>
                <div v-if="!detail.isApply">为核实申请信息，为您申请公益救助项目，需您完善真实信息。</div>
                <div v-else style="text-align: center">请将项目名发给小助手，获取报名表或链接</div>
                <div v-if="!detail.isApply" align="center" style="margin-top: 12px;color: #9D9D9D">
                    <van-button class="clinic-detail-footer-right-btn" type="danger" round size="large" @click="goLogin()" color="#0FB7AD">
                        立即填写
                    </van-button>
                </div>
                <div v-else style="text-align: center">
                    <img width="220" src="/static/qrcode/gyjz.png" alt="">
                    <div>长按识别添加</div>
                </div>
            </van-dialog>

            <van-dialog class="feedback" v-model="openFeedback" :showConfirmButton="false">

                <template slot="title">
                    <div class="close-pop" @click="openFeedback = false">
                        <img src="/static/bytx/popup_close_icon.svg" alt="">
                    </div>
                    <h3>联系小助手</h3>
                </template>

                <div class="clear"></div>

                <div>战友您好，请您长按识别下方二维码添加小助手，博医同行将因您变得更好。</div>

                <div align="center" style="margin-top: 10px">
                    <img src="/static/bytx/qrcode/gyjz_v2.jpeg" alt="">
                </div>

            </van-dialog>

            <van-overlay :show="showShareDialog" @click="showShareDialog = false">
                <div class="share-box">
                    <div class="block">
                        请点击 “...”，再点击发送给朋友 | <span>知道啦</span>
                    </div>
                    <div class="share-box-bottom">
                        <img src="/static/bytx/detail_forward_2_img.png" alt="">
                    </div>
                </div>
            </van-overlay>

        </div>

    </div>

</template>

<script>
    import Interface from "@/util/interface"
    import communityDetailSkeleton from "@/skeleton/articleDetailSkeleton"
    import checkLogin from "../../../mixins/checkLogin";
    import {LocationHref} from '@/util/common'

    export default {
        name: 'community-detail',
        mixins:[checkLogin],
        components :{
            'community-detail-skeleton' : communityDetailSkeleton
        },
        data() {
            return {
                id:0,
                value: "",
                active: "",
                category_id :0,
                category_child_id:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                community:{},
                comment:[],
                comment_text:"",
                loading:true,
                share_data :{},
                showShareDialog:false,
                htmlUrl:"",
                isShow:false,
                status:"",
                comment_id :0,
                to_user_id:0,
                comment_placeholder:"写评论",
                user_id:0,
                detail:{},

                formData: {
                    name:"",
                    mobile:"",
                    sex:"男",
                    identity_name:"患者本人",
                    identity:1,
                },

                applyFormDialog:false,
                openFeedback:false,
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'detail') {
                    Interface.getData('get', Interface.community.detail+this.id).then((res) => {
                        if (res.code == 0 ) {
                          this.detail = res.data
                          if(this.detail){
                            Interface.getShareInfo(this,this.detail.title,"","")
                          }
                          setTimeout(()=>{this.loading = false;},500)
                        } else {
                          setTimeout(()=>{this.loading = false;},500)
                          this.$toast.fail(res.message)
                        }

                    })
                } else if (scene === 'comment') {
                    let params = {
                        content_id:this.id,
                        comment_type:8,
                        page:1,
                        pageSize:999
                    }
                    Interface.getData('get', Interface.comment,params).then((res) => {
                        if(res.code == 0){
                            if(res.data.list)
                                this.comment = res.data.list
                        } else {
                          setTimeout(()=>{this.loading = false;},500)
                          this.$toast.fail(res.message)
                        }
                    })
                }else if (scene === 'footprint') {
                    let params = {
                        id : this.id,
                        type:8,
                    }
                    Interface.getData('post', Interface.footprint,params).then((res) => {

                    })
                }
            },
            changeCategory(){
                this.fetch('community')
            },
            favorite(){
                Interface.getData('get', Interface.community.favorite+this.id).then((res) => {
                    if(res.code == 0){
                        this.detail.isFavorite = !this.detail.isFavorite
                    }
                })
            },
            checkPhone(tel){
                return /^1[3456789]\d{9}$/.test(tel);
            },
            apply(){
                if(!this.checkPhone(this.formData.mobile)){
                    this.$toast.fail("手机号格式不正确")
                    return
                }
                switch (this.formData.identity_name){
                    case "患者本人":
                        this.formData.identity=1;
                        break;
                    case "患者家属":
                        this.formData.identity=2;
                        break;
                    case "医务工作者":
                        this.formData.identity=3;
                        break;
                    default:
                        this.formData.identity=4;
                        break;
                }


                let params = {
                    ...this.formData
                }
                Interface.getData('get', Interface.user.apply_community+this.id,params).then((res) => {
                    if(res.code == 0){
                        this.openFeedback = true
                        this.applyFormDialog = false
                    }
                })
              Interface.footPrint(31,0,0,"完成救助申请")
            },
            createComment(){

                if(!this.userLoginCheck()){
                    return
                }

                if (this.comment_text == ""){
                    return;
                }
                let params = {
                    content_id:this.id,
                    comment_type:8,
                    content:this.comment_text,
                }
                if(this.comment_id != 0){
                    params.comment_id = +this.comment_id
                }
                if(this.to_user_id != 0){
                    params.to_user_id = +this.to_user_id
                }
                Interface.getData('post', Interface.comment,params).then((res) => {
                    if(res.code == 0){
                        this.$toast.success("发送成功")
                        this.fetch('comment')
                        this.goComment()
                        this.comment_text = ""
                        this.comment_placeholder = "写评论"
                        this.comment_id=0
                        this.to_user_id=0
                    }
                })
            },
            reComment(item){
                this.comment_placeholder = '回复'+item.nickname
                this.comment_id = item.id
            },
            reCommentChild(item){
                this.comment_placeholder = '回复'+item.nickname
                this.comment_id = item.comment_id
                this.to_user_id = item.user_id
            },
            pointLikeComment(item){
                Interface.getData('get', Interface.pointLikeComment+item.id).then((res) => {
                    if(res.code == 0){
                        item.isLike = !item.isLike
                        if (item.isLike){
                            item.like_count += 1
                        }else{
                            item.like_count -= 1
                        }
                    }
                })

            },
            goComment(){
                this.$el.querySelector(".comment").scrollIntoView()
            },
            openShareData(){
                this.showShareDialog = true
            },
            pointLike() {
                Interface.getData('get', Interface.community.like + this.id).then((res) => {
                    if (res.code == 0) {
                        this.detail.isLike = !this.detail.isLike
                        this.detail.like_count = !this.detail.isLike ? parseInt(this.detail.like_count) - 1 : parseInt(this.detail.like_count) + 1
                    }
                })
            },
            changeIdentity(){
                this.$forceUpdate()
            },
            goLogin(){
                //申请
                let user = localStorage.getItem("user");
                user = JSON.parse(user)
                sessionStorage.setItem("back-url", this.$route.path)
                sessionStorage.setItem("apply",JSON.stringify({
                    apply:'community',apply_id:this.id
                }))
                this.goAddInfo(user)
            },

            closeApplyForm(){
                this.applyFormDialog = false
            },
            goWechat(){
                LocationHref("https://work.weixin.qq.com/kfid/kfc80e2e65a20c7e4b8")
                Interface.footPrint(34,0,0,"点击联系客服")
            },
            checkUserLogin(){
                this.userLoginCheck()
            },
            applyHelp(item) {
                if(!item.isApply){
                    this.applyFormDialog = true
                }
                if (item && item.id) {
                    Interface.footPrint(30,item.id,0,"点击救助项目模块中申请救助")
                } else {
                    Interface.footPrint(30,0,0,"点击救助项目模块中申请救助")
                }
            },

        },
        created() {
            this.id = this.$route.params.id
            Interface.footPrint(29,this.id,0,"浏览公益项目详情")
            this.fetch('detail')
            this.fetch('comment')
            this.fetch('footprint')
        },
    }
</script>

<style lang="scss">
    @import "./index";
    @import "../../../components/comment";
</style>



// WEBPACK FOOTER //
// src/views/community/detail/index.vue